import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React, { useMemo } from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';
import {
    ChildEventProps,
    GACodes,
    SeriesDatesDropdownScopedProps,
} from '../../../../types';
import { getFormattedDate } from '../../../utils/localizedDates';
import './ChildEventsDropdown.scss';

type ChildEventsDropdownProps = Array<{
    value: string;
    display: string;
}>;

const trackAnalytics = (action: string) => {
    trackAnalyticsEvent({
        action: action,
        category: GACodes.GA_CATEGORY_LISTING,
        label: GACodes.GA_LABEL_SECONDARY,
    });
};

export const ChildEventsDropdown = (props: SeriesDatesDropdownScopedProps) => {
    const { childEvents, eventId, isOnlineEvent } = props;
    const seriesDates: ChildEventsDropdownProps = useMemo(
        () =>
            childEvents.map(({ id, start, locale }: ChildEventProps) => ({
                value: id,
                display: getFormattedDate({
                    date: start,
                    format: 'ddd, MMM D (LT)',
                    isOnlineEvent,
                    localizedFormat: 'ddd, MMM D (LT z)',
                    locale,
                }),
            })),
        [childEvents, isOnlineEvent],
    );

    const handleSeriesDropDownOnFocus = () => {
        trackAnalytics(GACodes.GA_ACTION_SELECT_DATE_ATTEMPT);
    };

    const handleSeriesDropDownOnChange = (id: string) => {
        trackAnalytics(GACodes.GA_ACTION_SELECT_DATE);

        window.location.href = window.location.href.replace(eventId, id);
    };

    const childEventsItems = seriesDates.map(({ value, display }) => (
        <option value={value} key={value}>
            {display}
        </option>
    ));

    return (
        <select
            onChange={(e) => handleSeriesDropDownOnChange(e.target.value)}
            onFocus={handleSeriesDropDownOnFocus}
            className="child-events-dropdown eds-btn eds-btn--anchor eds-link"
            style={{ textDecoration: 'none' }}
            value={'selected'}
            aria-label="More options"
            data-heap-id={LISTING_HEAP_IDS.CHILD_EVENTS_DROPDOWN}
        >
            <option value={'selected'} disabled>
                {gettext('More options')}
            </option>
            {childEventsItems}
        </select>
    );
};

export default ChildEventsDropdown;
